module.exports = __webpack_public_path__ + "img/at.d04f6bc4.svg";